import { useEffect } from "react";

export const useIntersectionObserver = (
  selector: string,
  threshold: number = 0.1,
  trigger: boolean = true
): void => {
  useEffect(() => {
    if (!trigger) return;

    const elements = document.querySelectorAll<HTMLElement>(selector);
    if (elements.length === 0) return;

    const callback: IntersectionObserverCallback = (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("fade-in");
          observer.unobserve(entry.target);
        }
      });
    };

    const observer = new IntersectionObserver(callback, {
      rootMargin: "0px",
      threshold,
    });

    elements.forEach((element) => observer.observe(element));

    return () => {
      elements.forEach((element) => observer.unobserve(element));
    };
  }, [selector, threshold, trigger]); // 👈 important d'ajouter `trigger`
};
